import { render, staticRenderFns } from "./ProducaoPFForm.vue?vue&type=template&id=655fc9fc&scoped=true"
import script from "./ProducaoPFForm.vue?vue&type=script&lang=js"
export * from "./ProducaoPFForm.vue?vue&type=script&lang=js"
import style0 from "./ProducaoPFForm.vue?vue&type=style&index=0&id=655fc9fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655fc9fc",
  null
  
)

export default component.exports